import { render, staticRenderFns } from "./productionDemand.vue?vue&type=template&id=c52e0476&scoped=true"
import script from "./productionDemand.vue?vue&type=script&lang=js"
export * from "./productionDemand.vue?vue&type=script&lang=js"
import style0 from "./productionDemand.vue?vue&type=style&index=0&id=c52e0476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e0476",
  null
  
)

export default component.exports